// JsaConfinedSpace
export class JsaConfinedSpace {
  constructor(data = {}) {
    this.cseEntryYes = data.cse_entry_yes || false;
    this.cseEntryNo = data.cse_entry_no || false;
    this.cseBreakingPlaneYes = data.cse_breaking_plane_yes || false;
    this.cseBreakingPlaneNo = data.cse_breaking_plane_no || false;
    this.csePermitEwi = data.cse_permit_ewi || false;
    this.csePermitClient = data.cse_permit_client || false;
    this.csePermitClientApproved = data.cse_permit_client_approved || false;
    this.csePermitClientNotApproved =
      data.cse_permit_client_not_approved || false;
    this.cseAdminNotifiedYes = data.cse_admin_notified_yes || false;
    this.cseAdminNotifiedNo = data.cse_admin_notified_no || false;
    this.cseAdminNotificationTime = data.cse_admin_notification_time || "";
    this.cseAdminNotificationDate = data.cse_admin_notification_date || "";
    this.cseAdminName = data.cse_admin_name || "";
  }
  // Reset Functions
  resetCseEntryData() {
    this.cseBreakingPlaneYes = false;
    this.cseBreakingPlaneNo = false;
    this.csePermitEwi = false;
    this.csePermitClient = false;
    this.csePermitClientApproved = false;
    this.csePermitClientNotApproved = false;
    this.cseAdminNotifiedYes = false;
    this.cseAdminNotifiedNo = false;
    this.cseAdminNotificationTime = "";
    this.cseAdminNotificationDate = "";
    this.cseAdminName = "";
  }

  resetCseBreakingPlaneData() {
    this.cseBreakingPlaneYes = false;
    this.csePermitEwi = false;
    this.csePermitClient = false;
    this.csePermitClientApproved = false;
    this.csePermitClientNotApproved = false;
    this.cseAdminNotifiedYes = false;
    this.cseAdminNotifiedNo = false;
    this.cseAdminNotificationTime = "";
    this.cseAdminNotificationDate = "";
    this.cseAdminName = "";
  }
  // Update Functions
  updateCseEntryYes(value) {
    if (!value) {
      this.cseEntryYes = false;
      this.resetCseEntryData();
    } else {
      this.cseEntryYes = value;
      this.cseEntryNo = false;
    }
  }

  updateCseEntryNo(value) {
    if (!value) {
      this.cseEntryNo = false;
    } else {
      this.cseEntryNo = value;
      this.cseEntryYes = false;
      this.resetCseEntryData();
    }
  }

  updateCseBreakingPlaneYes(value) {
    if (!value) {
      this.resetCseBreakingPlaneData();
    } else {
      this.cseBreakingPlaneYes = value;
      this.cseBreakingPlaneNo = false;
    }
  }

  updateCseBreakingPlaneNo(value) {
    if (!value) {
      this.cseBreakingPlaneNo = false;
    } else {
      this.cseBreakingPlaneNo = value;
      this.resetCseBreakingPlaneData();
    }
  }

  updateCsePermitEwi(value) {
    if (!value) {
      this.csePermitEwi = false;
    } else {
      this.csePermitEwi = value;
    }
  }

  updateCsePermitClient(value) {
    if (!value) {
      this.csePermitClient = false;
      this.csePermitClientApproved = false;
      this.csePermitClientNotApproved = false;
    } else {
      this.csePermitClient = value;
    }
  }

  updateCsePermitClientApproved(value) {
    if (!value) {
      this.csePermitClientApproved = false;
    } else {
      this.csePermitClientApproved = value;
      this.csePermitClientNotApproved = false;
    }
  }

  updateCsePermitClientNotApproved(value) {
    if (!value) {
      this.csePermitClientNotApproved = false;
    } else {
      this.csePermitClientNotApproved = value;
      this.csePermitClientApproved = false;
    }
  }

  updateCseAdminNotifiedYes(value) {
    if (!value) {
      this.cseAdminNotifiedYes = false;
      this.cseAdminName = "";
      this.cseAdminNotificationDate = "";
      this.cseAdminNotificationTime = "";
    } else {
      this.cseAdminNotifiedYes = value;
      this.cseAdminNotifiedNo = false;
    }
  }

  updateCseAdminNotifiedNo(value) {
    if (!value) {
      this.cseAdminNotifiedNo = false;
    } else {
      this.cseAdminNotifiedNo = value;
      this.cseAdminNotifiedYes = false;
      this.cseAdminName = "";
      this.cseAdminNotificationDate = "";
      this.cseAdminNotificationTime = "";
    }
  }

  updateCseAdminNotificationTime(value) {
    if (!value) {
      this.cseAdminNotificationTime = "";
    } else {
      this.cseAdminNotificationTime = value;
    }
  }

  updateCseAdminNotificationDate(date) {
    if (!date) {
      this.cseAdminNotificationDate = "";
    } else {
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const year = date.getFullYear();
      this.cseAdminNotificationDate = `${year}-${month}-${day}`;
    }
  }

  updateCseAdminName(value) {
    if (!value) {
      this.cseAdminName = "";
    } else {
      this.cseAdminName = value;
    }
  }

  // To json for sending to the database
  toJson() {
    return {
      cse_entry_yes: this.cseEntryYes,
      cse_entry_no: this.cseEntryNo,
      cse_breaking_plane_yes: this.cseBreakingPlaneYes,
      cse_breaking_plane_no: this.cseBreakingPlaneNo,
      cse_permit_ewi: this.csePermitEwi,
      cse_permit_client: this.csePermitClient,
      cse_permit_client_approved: this.csePermitClientApproved,
      cse_permit_client_not_approved: this.csePermitClientNotApproved,
      cse_admin_notified_yes: this.cseAdminNotifiedYes,
      cse_admin_notified_no: this.cseAdminNotifiedNo,
      cse_admin_notification_time: this.cseAdminNotificationTime,
      cse_admin_notification_date: this.cseAdminNotificationDate,
      cse_admin_name: this.cseAdminName,
    };
  }

  // Helper for single and multi-field patches to be sent via websocket
  toPatch(fields, jsaId, action = "update") {
    const fieldMap = {
      cseEntryYes: "cse_entry_yes",
      cseEntryNo: "cse_entry_no",
      cseBreakingPlaneYes: "cse_breaking_plane_yes",
      cseBreakingPlaneNo: "cse_breaking_plane_no",
      csePermitEwi: "cse_permit_ewi",
      csePermitClient: "cse_permit_client",
      csePermitClientApproved: "cse_permit_client_approved",
      csePermitClientNotApproved: "cse_permit_client_not_approved",
      cseAdminNotifiedYes: "cse_admin_notified_yes",
      cseAdminNotifiedNo: "cse_admin_notified_no",
      cseAdminNotificationTime: "cse_admin_notification_time",
      cseAdminNotificationDate: "cse_admin_notification_date",
      cseAdminName: "cse_admin_name",
    };

    const patch = {
      patch_type: "jsa_confined_space",
      jsa_id: jsaId,
      action,
    };

    for (const [key, value] of Object.entries(fields)) {
      const dbField = fieldMap[key];
      if (dbField) {
        patch[dbField] = value;
      }
    }

    return patch;
  }
}
